import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { v4 } from "uuid";
import copyTextToClipBoard from "../../utility/Clipboard";
import CopyClipboardIcon from "../CopyClipboardIcon/CopyClipboardIcon";
import "./ContactDetails.css";

import { useAppConfig } from "../../providers/AppConfigProvider";

import getPayment from "../../services/Payment";
import { getGiftCard } from "../../services/paymentService";
import updateContactAttributes from "../../services/contactAttributesService";
import storeCCDetails from "../../services/chatDataService";

import Model from "../../constants/Model";
import _ from "lodash";
import {
  downloadAttachment,
  getAttachment,
} from "../../services/awsApiService";
import { EventEmitter } from "../../utility/events";
import AttachementComp from "./AttachementComp";

import Spinner from "react-bootstrap/Spinner";
import { userDetails } from "../../services/userDetailsService";
import {
  attributeSchmema,
  queue_group_mapping,
  finalContact,
} from "../../constants/ccpAttributeSchema";
import { buildAttributeValue, isAttributeKeyExist } from "../../utility/util";

const { FORM_PAYMENT, URL_PAYMENT, PAYMENT_OBJECT } = Model;
console.log("Endpoints: ", process.env.REACT_APP_HS_PAYMENT_QC_ARN_EN, process.env.REACT_APP_CONNECT_INSTANCE_NAME, process.env.REACT_APP_HS_PAYMENT_QC_ARN_ES, process.env.REACT_APP_CONNECT_LOGIN_ENDPOINT);
// MT-1436 - Quick Connect ARNs for Home Services Payment IVR (set per environment via .env)
const HS_PAYMENT_QUICK_CONNECT_ARN_EN = process.env.REACT_APP_HS_PAYMENT_QC_ARN_EN;
const HS_PAYMENT_QUICK_CONNECT_ARN_ES = process.env.REACT_APP_HS_PAYMENT_QC_ARN_ES;
// const HS_PAYMENT_QUICK_CONNECT_ARN_EN = "arn:aws:connect:us-east-1:977727921638:instance/d1f2ce82-7099-466a-83e7-80314170185c/transfer-destination/cff7d4e7-af33-4982-85b1-d929bb031b8f";
// const HS_PAYMENT_QUICK_CONNECT_ARN_ES = "arn:aws:connect:us-east-1:977727921638:instance/d1f2ce82-7099-466a-83e7-80314170185c/transfer-destination/4d1e3434-9b33-41df-93f8-bf4a9dc850f1";
// const HS_PAYMENT_QUICK_CONNECT_ARN_ES = "arn:aws:connect:us-east-1:977727921638:instance/d1f2ce82-7099-466a-83e7-80314170185c/transfer-destination/ecd111f0-e41f-403b-b134-6121f5d15c81";

// MT-1436 - Validate Stripe Customer ID format: cus_ + alphanumeric, max 255 chars
const isValidStripeCustomerId = (id) => /^cus_[A-Za-z0-9]{1,251}$/.test(id);

const ContactDetails = ({ contactSet }) => {
  console.log("ContactDetails ::", contactSet);
  const { selectContact, endContactId } = useAppConfig();
  const [currentContact, setCurrentContact] = useState(null);
  const [GiftCrdNbr, setGiftCrdNbr] = useState(null);
  const [paymentList, setPaymentList] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]);
  const [chatSession, setChatSession] = useState(null);
  const [buttonDisable, setButtonDisable] = useState({
    token: false,
    attachment: false,
  });
  const [userDetailsList, setUserDetailsList] = useState([]);
  const [paymentSupport, setPaymentSupport] = useState(true);
  const [finalSchema, setFinalSchema] = useState({});

  // MT-1436 - Stripe Customer ID + Quick Connect transfer
  const [stripeCustomerId, setStripeCustomerId] = useState("");
  const [isTransferring, setIsTransferring] = useState(false);
  const [transferStatus, setTransferStatus] = useState(null);

  const [chatPaymentId, setChatPaymentId] = useState("");

  const updateUserDetailsState = (userObj) => {
    const userIndex = _.findIndex(userDetailsList, {
      initialContactId: userObj.initialContactId,
    });
    if (userIndex < 0) {
      setUserDetailsList((cur) => [...cur, userObj]);
    }
  };

  const getUserDetails = async (input) => {
    try {
      const userResult = await userDetails(input);
      updateUserDetailsState(userResult.Item);
    } catch (error) {
      console.log("error in getUserDetails", error);
    }
  };

  useEffect(() => {
    contactSet.forEach(function (val) {
      if (selectContact && selectContact === val.contactId) {
        setCurrentContact(val);
      }
    });
  });

  const checkForGiftCard = async (req) => {
    try {
      const giftCardResult = await getGiftCard(req.contactId);
      if ("giftCardNo" in giftCardResult) {
        setGiftCrdNbr(giftCardResult.giftCardNo);
      } else {
        setGiftCrdNbr("NA");
      }
    } catch (error) {
      setGiftCrdNbr("NA");
      console.log("giftCardResult error", error);
    }
  };

  useEffect(() => {
    if (selectContact) {
      if (!_.find(userDetailsList, { initialContactId: selectContact })) {
        getUserDetails(selectContact);
      } else {
        isPaymentSupport();
      }
      chechAttachment(2000);
      checkForGiftCard({ contactId: selectContact });
    }
  }, [selectContact]);

  useEffect(() => {
    if (userDetailsList.length > 0) {
      isPaymentSupport();
    }
  }, [userDetailsList]);

  useEffect(() => {
    EventEmitter.subscribe("CHECK_PAYMENT_STATUS", (val) => {
      if (val.paymentType === "PAYMENT_SUCCESS") {
        getCCInfoDetails(val.ContactId);
      } else if (val.paymentType === "PAYMENT_ERROR") {
        getCCInfoDetails(val.ContactId);
      }
    });

    EventEmitter.subscribe("ATTACHMENT_LIST", (response) => {
      setChatSession(response.chat_session.chatClient);
      setAttachmentList((prev) => {
        let next = prev;
        next.length = 0;
        next = response.attachments;
        return next;
      });
    });

    EventEmitter.subscribe("CONTACT_ACCEPTED", (contact) => {
      console.log("contact.onAccepted 2");
      const originalContactId = contact.getOriginalContactId()
        ? contact.getOriginalContactId()
        : contact.getContactId();
      if (!_.find(userDetailsList, { initialContactId: originalContactId })) {
        getUserDetails(originalContactId);
      }
    });

    return () => {
      EventEmitter.unsubscribe("CHECK_PAYMENT_STATUS");
      EventEmitter.unsubscribe("ATTACHMENT_LIST");
      EventEmitter.unsubscribe("CONTACT_ACCEPTED");
    };
  }, []);

  const updatePaymentState = (paymentObj) => {
    const paymentIndex = _.findIndex(paymentList, {
      contactId: paymentObj.contactId,
    });
    if (paymentIndex > -1) {
      setPaymentList((current) =>
        current.map((obj) => {
          if (obj.contactId === paymentObj.contactId) {
            return {
              ...obj,
              ccDetails: paymentObj.ccDetails,
              message: paymentObj.message,
              type: paymentObj.type,
            };
          }
          return obj;
        })
      );
    } else {
      setPaymentList((current) => [...current, paymentObj]);
    }
    setTimeout(() => {
      setButtonDisable({ ...buttonDisable, token: false });
    }, 1000);
  };

  const getCCInfoDetails = async (contactId) => {
    setButtonDisable({ ...buttonDisable, token: true });
    const paymentObj = PAYMENT_OBJECT();
    paymentObj.contactId = contactId;
    const response = await getPayment(contactId);

    if (response.status === 200) {
      paymentObj.ccDetails = response.data.listOfCC;
      paymentObj.message = "PAYMENT_COLLECTED";
    } else {
      paymentObj.message = "PAYMENT_NA";
    }
    updatePaymentState(paymentObj);
  };

  // Force clear the contact details from view
  useEffect(() => {
    if (
      endContactId != null &&
      currentContact &&
      currentContact.contactId &&
      endContactId === currentContact.contactId
    ) {
      setCurrentContact(null);
    }
  }, [endContactId]);

  const requestForPayment = (request) => {
    EventEmitter.dispatch("PAYMENT_REQUEST", request);

    const paymentObj = PAYMENT_OBJECT();
    paymentObj.contactId = selectContact;
    paymentObj.message = "PAYMENT_REQUEST";
    paymentObj.type = request.TYPE;

    updatePaymentState(paymentObj);
  };

  const chechAttachment = (time) => {
    setAttachmentList([]);
    setTimeout(() => {
      EventEmitter.dispatch("CHECK_ATTACHMENTS");
    }, time ? time : 100);
  };

  const isPaymentSupport = () => {
    const res = _.find(userDetailsList, function (val) {
      if (val.initialContactId === selectContact && val.isCookieEnabled) {
        return true;
      }
    });
    setPaymentSupport(!!res);
  };

  // MT-1436 - Reset transfer form when active contact changes
  useEffect(() => {
    setStripeCustomerId("");
    setIsTransferring(false);
    setTransferStatus(null);
    setChatPaymentId("");
  }, [selectContact]);

  // MT-1436 - 1-click: update paymentCustomerId attribute then immediately initiate Quick Connect transfer
  const handleTransfer = async (endpointARN) => {
    if (!isValidStripeCustomerId(stripeCustomerId) || !currentContact || isTransferring) return;

    console.log("MT-1436 handleTransfer - started", { contactId: currentContact.contactId, endpointARN });
    setIsTransferring(true);
    setTransferStatus(null);

    try {
      // Step 1: Update paymentCustomerId contact attribute via backend Lambda
      const initialContactId = currentContact.originalContactId || currentContact.contactId;
      console.log("MT-1436 Step 1 - updating paymentCustomerId:", { stripeCustomerId, initialContactId });
      await updateContactAttributes(initialContactId, { paymentCustomerId: stripeCustomerId });
      console.log("MT-1436 Step 1 - contact attribute updated successfully");

      // Step 2: Get live contact from the Connect agent
      console.log("MT-1436 Step 2 - getting live contact for contactId:", currentContact.contactId);
      const liveContact = await new Promise((resolve, reject) => {
        window.connect.agent((agent) => {
          const contact = agent.getContacts().find((c) => c.getContactId() === currentContact.contactId);
          if (contact) {
            console.log("MT-1436 Step 2 - live contact found");
            resolve(contact);
          } else {
            reject(new Error("Live contact not found for contactId: " + currentContact.contactId));
          }
        });
      });

      // Step 3: Initiate Quick Connect transfer
      const endpoint = {
        endpointARN,
        type: window.connect.EndpointType.QUEUE,
      };
      console.log("MT-1436 Step 3 - calling addConnection with endpoint:", endpoint);

      await new Promise((resolve, reject) => {
        liveContact.addConnection(endpoint, {
          success: (data) => {
            console.log("MT-1436 Step 3 - addConnection success:", data);
            resolve(data);
          },
          failure: (err) => {
            console.log("MT-1436 Step 3 - addConnection failed:", err);
            reject(err);
          },
        });
      });

      console.log("MT-1436 handleTransfer - transfer initiated successfully");
      setTransferStatus("success");
      // Reset form so agent must start over for any subsequent transfer
      setStripeCustomerId("");
    } catch (error) {
      console.log("MT-1436 handleTransfer - caught error:", error);
      setTransferStatus("error");
    } finally {
      setIsTransferring(false);
    }
  };

  const downloadAttachmentContent = async (content) => {
    const connectionDetails = await chatSession.controller.getConnectionToken();
    const awsSdkResponse = await getAttachment(
      connectionDetails.chatTokenTransport.participantToken,
      content.AttachmentId
    );
    const downloadResponse = await downloadAttachment(awsSdkResponse.Url);

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([downloadResponse.data]));
    link.setAttribute("download", content.AttachmentName);
    link.click();
  };

  const getPDToken = async (event, contactId) => {
    getCCInfoDetails(contactId);
  };

  // ACC-324
  const findNameAndValue = (array, searchName) => {
    const foundItem = array.find((item) => item.name === searchName);
    return foundItem ? { name: foundItem.name, value: foundItem.value } : "notFound";
  };

  const findGroup = (queue, groupName) => {
    for (const group in finalContact) {
      if (
        finalContact[group].queue === queue &&
        finalContact[group].groupName === groupName
      ) {
        return group;
      }
    }
    return null;
  };

  // ACC-315
  const mappingGroups = (queue, contactKey) => {
    let newFinalSchema = {};
    let foundQueueGrp = findGroup(queue, contactKey);

    Object.keys(queue_group_mapping).forEach((value) => {
      const values = queue_group_mapping[value];

      if (foundQueueGrp !== null) {
        return;
      }

      if (Array.isArray(values)) {
        if (values.includes(queue)) {
          foundQueueGrp = value;
        }
      }

      if (typeof values === "object" && !Array.isArray(values)) {
        if (
          values.type === "regex" &&
          queue.startsWith(values.value.ST) &&
          !queue.endsWith(values.value.NOTEN)
        ) {
          foundQueueGrp = value;
        }
      }
    });

    console.log("foundQueueGrp", foundQueueGrp);

    if (foundQueueGrp) {
      for (const property in attributeSchmema) {
        if (attributeSchmema.hasOwnProperty(property)) {
          newFinalSchema[property] = attributeSchmema[property].filter(
            (obj) => Array.isArray(obj.queueGrp) && obj.queueGrp.includes(foundQueueGrp)
          );
        }
      }
    }

    console.log("Final Schema: ", newFinalSchema);
    return newFinalSchema;
  };

  useEffect(() => {
    if (currentContact) {
      const result = findNameAndValue(currentContact.attributes, "msgGroup");
      const msgGroup = result.value;
      console.log("grupNameFind", msgGroup);
      const finalBuildSchema = mappingGroups(currentContact.queue, msgGroup);
      setFinalSchema(Object.keys(finalBuildSchema).length > 0 ? finalBuildSchema : {});
      console.log("currentContact", currentContact);
    } else {
      console.log("NoCurrentCountact");
    }
  }, [currentContact]);

  return currentContact ? (
    <div className="contact-details-root">
      <div className="p-1 container-title">
        <span>Contact Details</span>
      </div>
      <Container fluid className="contact-details">
        {currentContact.fName ? (
          <h6 className="contact-name">{currentContact.fName}</h6>
        ) : (
          ""
        )}
        <Row>
          <Col>
            <strong>Caller Details</strong>
          </Col>
        </Row>

        <Row>
          <Col xs={6}>
            <em>Primary Phone Number</em>
          </Col>
          <Col>
            {currentContact.phone}{" "}
            <CopyClipboardIcon value={currentContact.phone} />
          </Col>
        </Row>
        {_.findIndex(currentContact.attributes, { name: "altPhoneNumber" }) > 0 && (
          <Row>
            <Col xs={6}>
              <em>Alternative Phone Number</em>
            </Col>
            <Col>
              {
                currentContact.attributes[
                  _.findIndex(currentContact.attributes, { name: "altPhoneNumber" })
                ].value
              }
            </Col>
          </Row>
        )}
        {_.findIndex(currentContact.attributes, { name: "isMobile" }) > 0 && (
          <Row>
            <Col xs={6}>
              <em>Phone Number Type</em>
            </Col>
            <Col>
              {currentContact.attributes[
                _.findIndex(currentContact.attributes, { name: "isMobile" })
              ].value
                ? "Mobile"
                : "Non Mobile"}
            </Col>
          </Row>
        )}
        <Row>
          <Col xs={6}>
            <em>Queue</em>
          </Col>
          <Col>
            {currentContact.queueName}{" "}
            <CopyClipboardIcon value={currentContact.queueName} />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <em>Contact Id</em>
          </Col>
          <Col>
            {currentContact.contactId}{" "}
            <CopyClipboardIcon value={currentContact.contactId} />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <em>Dialed Number</em>
          </Col>
          <Col>
            {currentContact.dialedNumber}{" "}
            <CopyClipboardIcon value={currentContact.dialedNumber} />
          </Col>
        </Row>
        <Row></Row>
        <Row>
          <Col>
            <Button
              className="p-1 btn-sm"
              value={currentContact.groupCopy}
              onClick={(e) => copyTextToClipBoard(e)}
            >
              Copy to CRM
            </Button>
          </Col>
        </Row>
      </Container>

      {/* ACC-296 - Contact attributes section */}
      {Object.keys(finalSchema).length > 0 ? (
        Object.keys(finalSchema).map((value, key) => (
          <Container className="contact-attributes" key={key}>
            <Row>
              <Col>
                <strong>{value}</strong>
              </Col>
            </Row>
            {finalSchema[value].map(
              (attribute) =>
                isAttributeKeyExist(attribute, currentContact.attributes) > -1 && (
                  <Row key={v4()}>
                    <Col xs={6}>
                      <em>{attribute.UiName}</em>
                    </Col>
                    <Col>
                      {buildAttributeValue(attribute, currentContact.attributes)}
                    </Col>
                  </Row>
                )
            )}
          </Container>
        ))
      ) : (
        <Container className="contact-attributes">
          <Row>
            <Col>
              <strong>Attributes</strong>
            </Col>
          </Row>
          {currentContact.attributes.length > 0 ? (
            currentContact.attributes.map((attribute) => (
              <Row key={v4()}>
                <Col xs={6}>
                  <em>{attribute.name}</em>
                </Col>
                <Col>{attribute.value}</Col>
              </Row>
            ))
          ) : (
            <Row>
              <Col>
                <em>No attributes</em>
              </Col>
            </Row>
          )}
        </Container>
      )}

      {/* MT-1436 - Home Services Payment: Stripe Customer ID + Quick Connect Transfer (voice only) */}
      {currentContact.type === "voice" && (
        <Container className="contact-attributes">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="card-title text-center">Payment</h6>
              <div className="mb-2">
                <label className="form-label" htmlFor="stripeCustomerId">
                  <em>Customer Payment Id</em>
                </label>
                <input
                  id="stripeCustomerId"
                  type="text"
                  className={`form-control form-control-sm${
                    stripeCustomerId && !isValidStripeCustomerId(stripeCustomerId)
                      ? " is-invalid"
                      : ""
                  }`}
                  value={stripeCustomerId}
                  onChange={(e) => setStripeCustomerId(e.target.value)}
                  maxLength={255}
                />
                {stripeCustomerId && !isValidStripeCustomerId(stripeCustomerId) && (
                  <div className="invalid-feedback">Invalid Entry</div>
                )}
              </div>
              <div className="d-flex gap-2 flex-wrap">
                <Button
                  className="p-1 btn-sm"
                  disabled={!isValidStripeCustomerId(stripeCustomerId) || isTransferring}
                  onClick={() => handleTransfer(HS_PAYMENT_QUICK_CONNECT_ARN_EN)}
                >
                  {isTransferring ? (
                    <>
                      Transferring...{" "}
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    </>
                  ) : (
                    "Transfer (EN)"
                  )}
                </Button>
                <Button
                  className="p-1 btn-sm"
                  disabled={!isValidStripeCustomerId(stripeCustomerId) || isTransferring}
                  onClick={() => handleTransfer(HS_PAYMENT_QUICK_CONNECT_ARN_ES)}
                >
                  {isTransferring ? (
                    <>
                      Transferring...{" "}
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    </>
                  ) : (
                    "Transfer (ES)"
                  )}
                </Button>
              </div>
              {transferStatus === "success" && (
                <div className="text-success mt-1">
                  <small>Transfer initiated successfully.</small>
                </div>
              )}
              {transferStatus === "error" && (
                <div className="text-danger mt-1">
                  <small>Transfer failed. Please try again.</small>
                </div>
              )}
            </div>
          </div>
        </Container>
      )}

      {/* Chat-only: Credit card payment, device info, attachments */}
      {currentContact.type !== "voice" && (
        <>
          {GiftCrdNbr && (
            <Container className="contact-attributes mb-2">
              <Row>
                <Col xs={6}>
                  <strong>Gift Card</strong>
                </Col>
                <Col>
                  {GiftCrdNbr} <CopyClipboardIcon value={GiftCrdNbr} />
                </Col>
              </Row>
            </Container>
          )}

          {userDetailsList.map((o, i) => {
            if (o.initialContactId == selectContact && o.userDevice) {
              return (
                <Container fluid className="contact-details mb-2" key={i}>
                  <div className="card custom-card p-2">
                    <Row>
                      <Col xs={6}>
                        <strong>Device Type</strong>
                      </Col>
                      <Col>
                        <em>
                          {o.userDevice.isMobile
                            ? "Mobile"
                            : o.userDevice.isTablet
                            ? "Tablet"
                            : o.userDevice.isDesktop
                            ? "Desktop"
                            : ""}
                        </em>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={6}>
                        <strong>OS</strong>
                      </Col>
                      <Col>
                        <em>{`${o.userDevice.osName} - ${o.userDevice.osVersion}`}</em>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={6}>
                        <strong>BROWSER</strong>
                      </Col>
                      <Col>
                        <em>{o.userDevice.browserName}</em>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={6}>
                        <strong>Payment Form Support</strong>
                      </Col>
                      <Col>
                        <strong>
                          <em>{o.isCookieEnabled ? "YES" : "NO"}</em>
                        </strong>
                      </Col>
                    </Row>
                  </div>
                </Container>
              );
            }
          })}

          <Container>
            <div className="card custom-card">
              <div className="card-body">
                <h6 className="card-title text-center">Credit Card Info</h6>
                <p className="card-text m-0">
                  Please use below button to send type of payment request.
                </p>
                <div className="mb-2">
                  <label className="form-label mb-1" htmlFor="chatPaymentId">
                    <em>Customer Payment ID</em>
                  </label>
                  <input
                    id="chatPaymentId"
                    type="text"
                    className="form-control form-control-sm"
                    value={chatPaymentId}
                    onChange={(e) => setChatPaymentId(e.target.value)}
                  />
                </div>
                <div className="row">
                  {paymentSupport && (
                    <div className="col">
                      <Button
                        className="p-1 btn-sm"
                        disabled={!chatPaymentId}
                        onClick={async () => {
                          console.log("chatPaymentId:", chatPaymentId);
                          const initialContactId = currentContact.originalContactId || currentContact.contactId;
                          try {
                            await storeCCDetails(initialContactId, chatPaymentId);
                          } catch (error) {
                            console.log("storeCCDetails error:", error);
                          }
                          requestForPayment(FORM_PAYMENT);
                        }}
                      >
                        HS Payment Form
                      </Button>
                    </div>
                  )}
                  {/* <div className="col">
                    <Button
                      className="p-1 btn-sm"
                      onClick={() => requestForPayment(URL_PAYMENT)}
                    >
                      HS Payment Link
                    </Button>
                  </div> */}
                </div>

                {paymentList.map((obj, index) => {
                  if (selectContact === obj.contactId) {
                    if (obj.ccDetails) {
                      return (
                        <Container className="contact-attributes" key={index}>
                          {obj.ccDetails.token && (
                            <Row>
                              <Col xs={4}>
                                <strong>Token</strong>
                              </Col>
                              <Col>
                                {obj.ccDetails.token}{" "}
                                <CopyClipboardIcon value={obj.ccDetails.token} />
                              </Col>
                            </Row>
                          )}
                          {obj.ccDetails.maskedCard && (
                            <Row>
                              <Col xs={4}>
                                <strong>Masked Card</strong>
                              </Col>
                              <Col>
                                {obj.ccDetails.maskedCard}{" "}
                                <CopyClipboardIcon value={obj.ccDetails.maskedCard} />
                              </Col>
                            </Row>
                          )}
                          {obj.ccDetails.expiryDate && (
                            <Row>
                              <Col xs={4}>
                                <strong>Expiry Date</strong>
                              </Col>
                              <Col>
                                {obj.ccDetails.expiryDate}{" "}
                                <CopyClipboardIcon value={obj.ccDetails.expiryDate} />
                              </Col>
                            </Row>
                          )}
                          {obj.ccDetails.cardType && (
                            <Row>
                              <Col xs={4}>
                                <strong>cardType</strong>
                              </Col>
                              <Col>
                                {obj.ccDetails.cardType}{" "}
                                <CopyClipboardIcon value={obj.ccDetails.cardType} />
                              </Col>
                            </Row>
                          )}
                          {obj.message && (
                            <Row>
                              <Col xs={4}>
                                <strong>Message</strong>
                              </Col>
                              <Col>
                                {obj.message}{" "}
                                <CopyClipboardIcon value={obj.message} />
                              </Col>
                            </Row>
                          )}
                          {obj.type && (
                            <Row>
                              <Col xs={4}>
                                <strong>Type</strong>
                              </Col>
                              <Col>
                                {obj.type}{" "}
                                <CopyClipboardIcon value={obj.type} />
                              </Col>
                            </Row>
                          )}
                          {obj.status && (
                            <Row>
                              <Col xs={4}>
                                <strong>Status</strong>
                              </Col>
                              <Col>
                                {obj.status}{" "}
                                <CopyClipboardIcon value={obj.status} />
                              </Col>
                            </Row>
                          )}
                        </Container>
                      );
                    } else {
                      return (
                        <Container className="contact-attributes" key={index}>
                          <Row>
                            <Col xs={4}>
                              <strong>Status</strong>
                            </Col>
                            <Col>NA</Col>
                          </Row>
                        </Container>
                      );
                    }
                  }
                })}
              </div>
            </div>
          </Container>

          <Container className="contact-attributes">
            <Row>
              <Col>
                <Button
                  size="sm"
                  className="PD-button"
                  onClick={(e) => getPDToken(e, currentContact.contactId)}
                  disabled={buttonDisable.token}
                >
                  Get Token
                  {buttonDisable.token && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </Button>
              </Col>
            </Row>
          </Container>

          <Container className="contact-attributes">
            <Row>
              <Col>
                <button
                  type="button"
                  className="btn btn-primary p-1 btn-sm"
                  onClick={() => chechAttachment()}
                >
                  Check Attachments
                </button>
              </Col>
            </Row>
          </Container>

          <Container className="contact-attributes">
            {attachmentList.map((obj, index) => (
              <Row key={index}>
                <AttachementComp
                  data={obj}
                  fnDownLoadAttachement={downloadAttachmentContent}
                  key={index}
                />
              </Row>
            ))}
          </Container>
          <Container className="contact-attributes">&nbsp;</Container>
        </>
      )}
    </div>
  ) : (
    <div className="contact-details-root">
      <div className="p-1 container-title">
        <span>Contact Details</span>
      </div>
      <div className="no-contact-details">
        <em>No details</em>
      </div>
    </div>
  );
};

export default ContactDetails;
